module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-26.e65b28f5.jpg";